import { render, staticRenderFns } from "./HeatTab.vue?vue&type=template&id=4a4717a8&"
import script from "./HeatTab.vue?vue&type=script&lang=js&"
export * from "./HeatTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports